import React, { useState, useMemo } from 'react';
import type { Assistant } from '../../../api/types';
import { LoadingSpinner, EmptyState, Icon } from '../../shared';
import styles from './AssistantListPanel.module.css';

export interface AssistantListPanelProps {
  assistants: Assistant[];
  currentAssistantId?: string;
  onSelectAssistant: (assistantId: string) => void;
  isLoading?: boolean;
}

export const AssistantListPanel: React.FC<AssistantListPanelProps> = ({
  assistants,
  currentAssistantId,
  onSelectAssistant,
  isLoading = false,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredAssistants = useMemo(() => {
    if (!searchQuery.trim()) {
      return assistants;
    }
    const query = searchQuery.toLowerCase();
    return assistants.filter(
      (assistant) =>
        assistant.title.toLowerCase().includes(query) ||
        assistant.description?.toLowerCase().includes(query)
    );
  }, [assistants, searchQuery]);

  if (isLoading) {
    return (
      <div className={styles.panel}>
        <LoadingSpinner message="Loading assistants..." />
      </div>
    );
  }

  console.log("assistants in AssistantListPanel:",assistants);

  return (
    <div className={styles.panel}>
      <div className={styles.searchWrapper}>
        <div className={styles.searchContainer}>
          <Icon name="search" size={18} className={styles.searchIcon} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search assistants..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.listContainer}>
        {filteredAssistants.length === 0 ? (
          <EmptyState
            variant="compact"
            message={searchQuery ? 'No assistants found matching your search' : 'No assistants available'}
          />
        ) : (
          <div className={styles.list}>
            {filteredAssistants.map((assistant) => (
              <button
                key={assistant.assistant_id}
                className={`${styles.item} ${currentAssistantId === assistant.assistant_id ? styles.active : ''}`}
                onClick={() => onSelectAssistant(assistant.assistant_id)}
              >
                <div className={styles.icon}>
                  <Icon name="user" size={24} />
                </div>
                <div className={styles.content}>
                  <h4 className={styles.name}>{assistant.title}</h4>
                  {assistant.description && <p className={styles.description}>{assistant.description}</p>}
                </div>
                <Icon name="arrow-right" size={20} className={styles.arrow} />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
